export default class HtmlFunctions {
    static openFullScreen() {
        let elem:any = document.documentElement;
        let methodToBeInvoked = elem.requestFullscreen
        || elem.webkitRequestFullScreen
        || elem['mozRequestFullscreen']
        || elem['msRequestFullscreen'];
        if (methodToBeInvoked) methodToBeInvoked.call(elem);
    }

    /* Close fullscreen */
  static closeFullscreen() {
    // let elem = document.documentElement;
    let doc:any = document;
    doc.webkitExitFullscreen();
  }
}
